module.exports = "<svg viewBox=\"0 0 9 5\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7.97361 0H0.27673C0.0458711 0 -0.0830351 0.24375 0.0599336 0.410156L3.90837 4.87266C4.01853 5.00039 4.23064 5.00039 4.34196 4.87266L8.1904 0.410156C8.33337 0.24375 8.20446 0 7.97361 0Z\"/>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/html-loader!./static/icons/buttons/collapse_chevrons_down.svg
// module id = dRY8
// module chunks = 0